module.exports = fox._r("fonts/museosanscyrl-webfont.woff", __webpack_public_path__ + "fonts/3t2j1X7.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl-webfont.woff
// module id = 575
// module chunks = 2